/*
 * Project: BookingEngine
 * Module: components/common/ShareEmailSuccess.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ModalDialog } from 'bookingform';
import CheckFillIcon from '../icons/CheckFillIcon';

class ShareEmailSuccess extends React.Component {
  getActions() {
    return [
      {
        id: 'back',
        text: this.context.t('Share with more friends'),
        isClosable: true,
      },
      {
        id: 'done',
        text: this.context.t('DONE'),
        isClosable: false,
      },
    ];
  }

  getBody() {
    return (
      <div className="main-content">
        <p>{this.context.t('The information you wanted to share has been emailed to :')}</p>
        <ul className="demail-list demail-list--success font-weight-bold">
        {this.props.sharedEmails.map((shareEmail, index) => (
          <li className="demail-item" key={`email${index}`}>
            {shareEmail}
          </li>
        ))}
        </ul>
      </div>
    );
  }

  getTitle() {
    return (
      <header className="share-header">
        <CheckFillIcon />
        <span className="ml-1 share-header__title">{this.context.t('Email Sent')}</span>
      </header>
    );
  }

  render() {
    return (
      <ModalDialog
        titleElement={this.getTitle()}
        bodyElement={this.getBody()}
        actions={this.getActions()}
        clickHandler={this.props.onClose}
        isVisible
      />
    );
  }
}

ShareEmailSuccess.propTypes = {
  sharedEmails: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func,
};

ShareEmailSuccess.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect()(ShareEmailSuccess);
